import React from 'react';

/**
 * The one spinner for every busy control. White on filled buttons, cobalt on
 * outline/ghost ones, violet only where Robbie is the one working.
 */
export type SpinnerTone = 'white' | 'action' | 'robbie';

export interface SpinnerProps {
  tone?: SpinnerTone;
  size?: 'sm' | 'md';
  className?: string;
}

const tones: Record<SpinnerTone, string> = {
  white: 'border-white/35 border-t-white',
  action: 'border-action/20 border-t-action',
  robbie: 'border-robbie/20 border-t-robbie',
};

const sizes = { sm: 'h-[10px] w-[10px] border-[1.5px]', md: 'h-[13px] w-[13px] border-2' };

export const Spinner: React.FC<SpinnerProps> = ({ tone = 'action', size = 'md', className = '' }) => (
  <span
    aria-hidden="true"
    data-spinner=""
    className={`inline-block shrink-0 rounded-round motion-safe:animate-spin ${tones[tone]} ${sizes[size]} ${className}`}
  />
);

export default Spinner;
